const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';

export const getRandomString = (length) => {
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * alphabet.length);
    result += alphabet[randomIndex];
  }
  return result;
}

export const checkBatchimEnding = (word) => {
  if (typeof word !== 'string') return null;
  if (!word) return ''

  var lastLetter = word[word.length - 1];
  var uni = lastLetter.charCodeAt(0);

  if (uni < 44032 || uni > 55203) return null;

  return (uni - 44032) % 28 != 0;
}

export const callName = (name) => {
  return name + (checkBatchimEnding(name) ? '이' : '')
}

export const ofName = (firstName, lastName) => {
  return firstName + lastName + (checkBatchimEnding(lastName) ? '이의' : '의')
}

export const toName = (firstName, lastName) => {
  return firstName + lastName + (checkBatchimEnding(lastName) ? '이를' : '를')
}

export const byName = (firstName, lastName) => {
  return firstName + lastName + (checkBatchimEnding(lastName) ? '이가' : '가')
}

export const beName = (firstName, lastName) => {
  return firstName + lastName + (checkBatchimEnding(lastName) ? '이는' : '는')
}

export const stripParenthesizedText = (text) => {
  if (typeof text !== 'string') return text

  let result = text
  let previous

  do {
    previous = result
    result = result.replace(/\([^()]*\)/g, '')
  } while (result !== previous)

  return result
    .replace(/[^\S\r\n]{2,}/g, ' ')
    .replace(/[^\S\r\n]+(\r?\n)/g, '$1')
    .replace(/(\r?\n)[^\S\r\n]+/g, '$1')
    .trim()
}

export const toMD = (dateStr) => {
  const date = new Date(dateStr);
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${month}/${day}`
}

export const getDateString = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`
}
